/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import FormFooterView from '../../../../shared/views/PersonDetail/FormFooter.view';
import NavButton from '../../../../shared/views/Buttons/NavButton.view';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FLAGGED_CONTENTS_URL } from '../../FlaggedContentRouting.container';

const FlaggedContentDetailsFooterView = withRouter((props: RouteComponentProps): JSX.Element => {
	const goToTableHandler = (): void => {
		props.history.push(FLAGGED_CONTENTS_URL);
	};

	return (
		<FormFooterView>
			<NavButton onClick={goToTableHandler}>Zu den gemeldeten Beiträgen</NavButton>
		</FormFooterView>
	);
});

export default FlaggedContentDetailsFooterView;
